import { __makeTemplateObject } from "tslib";
import { Link } from "react-router-dom";
import styled from "styled-components";
export var SubitemContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  width: max-content;\n  min-width: 210px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  width: max-content;\n  min-width: 210px;\n"])));
export var SubitemHeader = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  text-decoration: none;\n  margin: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  svg {\n    flex-shrink: 0;\n    transition: transform 0.3s;\n    font-size: 20px;\n    fill: ", ";\n  }\n\n  span {\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: ", ";\n    line-height: 20px; /* 142.857% */\n    letter-spacing: 0.1px;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  text-decoration: none;\n  margin: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  svg {\n    flex-shrink: 0;\n    transition: transform 0.3s;\n    font-size: 20px;\n    fill: ", ";\n  }\n\n  span {\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: ", ";\n    line-height: 20px; /* 142.857% */\n    letter-spacing: 0.1px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.s;
}, function (_a) {
    var theme = _a.theme, isSubsubitem = _a.isSubsubitem;
    return isSubsubitem
        ? theme.colors.neutral.lightest
        : theme.colors.primary.lightest + "54";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var isSubsubitem = _a.isSubsubitem;
    return (isSubsubitem ? 500 : 700);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map